/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import urls from "../../api/urls";
// import envUrls from "../../../config/env-urls";

const dashboardsID = {
  ROLE_HOADMIN: "1b87db37-4530-41e1-99a6-4ff8302ceefd",
  ROLE_CPADMIN: "3259c661-0b6e-4664-b0c7-74aee2835c08",
};

const AllReports = () => {
  const { DATAZIP_GUEST_TOKEN } = urls;
  const dashboardId =
    JSON.parse(localStorage.getItem("userinfo")).roles[0] === "ROLE_HOADMIN"
      ? dashboardsID["ROLE_HOADMIN"]
      : dashboardsID["ROLE_CPADMIN"];

  const guestTokenApi = DATAZIP_GUEST_TOKEN;
  const userDetails = JSON.parse(localStorage.getItem("userId"));
  const userRole = JSON.parse(localStorage.getItem("userinfo"));
  // console.log("userDetails", userDetails, userRole.roles[0], guestTokenApi);

  useEffect(() => {
    const initDashboard = async () => {
      try {
        await refreshTokens();
      } catch (error) {
        console.error("Error initializing dashboard:", error);
      }
    };
    initDashboard();
    const tokenInterval = setInterval(refreshTokens, 4 * 60 * 1000);
    return () => clearInterval(tokenInterval);
  }, []);
  const getRLS = (role) => {
    let rls = [];
    if (userRole.roles[0] == "ROLE_CPADMIN") {
      rls = [
        {
          clause: `origin_channel_partner = '${userDetails.premises.premiseName}'`,
          dataset: 914,
        },
      ];
    }

    if (userRole.roles[0] === "ROLE_HOADMIN") {
      rls = [];
    }
    return rls;
  };
  const refreshTokens = async () => {
    try {
      const guestToken = await fetchGuestToken();
      embedDashboardWithToken(guestToken);
    } catch (error) {
      console.error("Error refreshing tokens:", error);
    }
  };
  const fetchGuestToken = async () => {
    try {
      const data = {
        username: "datazip.embed",
        password: "JNF0D*fa$cd4",
        user: {
          username: "datazip.embed",
        },
        resources: [
          {
            type: "dashboard",
            id: dashboardId,
          },
        ],
        rls: getRLS(),
      };

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: guestTokenApi,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(data),
      };
      const response = await axios.request(config);
      return response?.data?.token; // Return data for further use
    } catch (error) {
      console.error("Error fetching guest token:", error);
      throw error; // Propagate error for handling
    }
  };
  const embedDashboardWithToken = (token) => {
    embedDashboard({
      id: dashboardId,
      supersetDomain: "https://app.datazip.delcaper.com",
      mountPoint: document.getElementById("superset-container"),
      fetchGuestToken: () => token,
      dashboardUiConfig: {
        hideTitle: true,
        hideTab: false,
        hideChartControls: false,
      },
    });
    let iframe = document.querySelector("#superset-container>iframe");
    iframe.style.height = "87vh";
    iframe.style.width = "94vw";
    iframe.style.border = "none";
    iframe.style.padding = "10px 0 0 10px";
  };
  return (
    <>
      <div>
        <div id="superset-container"></div>
      </div>
    </>
  );
};

export default AllReports;
